import React from 'react';
import Form from '../../components/common/Form';
// import Joi from 'joi-browser';
import axios from 'axios';
import {getCurrentUserId, getJwt} from '../../services/authService';
import toastr from 'toastr';
import http from "../../services/httpService";


class ContactSupportModal extends Form {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            name: '',
            done: false,
            data: {
                message: ""
            },
            errors: {},
            accept: false,
            querySelected: 'Feedback'
        };
    }

    // schema = {
    //     message: Joi.string().required().label("Message")
    // };


    doSubmit = async (e) => {
        //const data = this.state.data;
        this.props.acceptModal(e);
        this.setState({accept: true});

        let type = document.querySelector('.query-selected p').innerHTML;
        // console.log('type: ', type);
        let message = document.querySelector('.text-message textarea').innerHTML;
        // console.log('message: ', message);
        // const user_id = await getCurrentUserId();
        // const user = await http.get('api/user/' + user_id, { headers: { authorization: getJwt() } });
        const user = await http.get('api/user_info', {headers: {authorization: getJwt()}});

        let name = user.data.data.name;
        // console.log('user name: ', name);

        let email = user.data.data.email;
        // console.log(email);

        try {
            axios.post('/support-mail', {
                "type": type,
                "message": message,
                "email": email,
                "name": name
            })
                .then(res => {
                    // console.log(res);
                    // console.log(res.data);
                    toastr.info(res.data.message);
                });
        } catch (ex) {
            toastr.error('Something went wrong, please try again.');
        }

    };

    selectQuery = (query) => {
        this.setState({
            querySelected: query
        })
    };


    render() {
        let {visible_modal, onClickAway, acceptModal} = this.props;

        return (

            <div id="contactSupportModal" className="modal" style={visible_modal ? {display: "block"} : {display: "none"}}>
                {/*<div className="modal-content">*/}
                {/*    <span  onClick={onClickAway}*/}

                {/*           className="fas fa-times"></span>*/}
                {/*    <div className="onboarding-panel contact-support-container">*/}
                {/*        <h3 className="m-m-b">Get in touch and we'll be glad to help you out.</h3>*/}
                {/*        /!*<div className="separator"></div>*!/*/}
                {/*        <p>Type of query</p>*/}
                {/*        <div className="queries-container">*/}
                {/*            <div*/}
                {/*                className={this.state.querySelected === 'Feedback' ? 'single-query query-selected' : 'single-query'}*/}
                {/*                onClick={() => this.selectQuery('Feedback')}>*/}
                {/*                <p>Feedback</p>*/}
                {/*            </div>*/}
                {/*            <div*/}
                {/*                className={this.state.querySelected === 'Feature request' ? 'single-query query-selected' : 'single-query'}*/}
                {/*                onClick={() => this.selectQuery('Feature request')}>*/}
                {/*                <p>Feature request</p>*/}
                {/*            </div>*/}
                {/*            <div*/}
                {/*                className={this.state.querySelected === 'Report a bug' ? 'single-query query-selected' : 'single-query'}*/}
                {/*                onClick={() => this.selectQuery('Report a bug')}>*/}
                {/*                <p>Report a bug</p>*/}
                {/*            </div>*/}
                {/*            <div*/}
                {/*                className={this.state.querySelected === 'Request a Custom Plan' ? 'single-query query-selected' : 'single-query'}*/}
                {/*                onClick={() => this.selectQuery('Request a Custom Plan')}>*/}
                {/*                <p>Request a Custom Plan</p>*/}
                {/*            </div>*/}
                {/*            <div*/}
                {/*                className={this.state.querySelected === 'Other' ? 'single-query query-selected' : 'single-query'}*/}
                {/*                onClick={() => this.selectQuery('Other')}>*/}
                {/*                <p>Other</p>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*        <div className="form-group m-m-b text-message">*/}
                {/*            {this.renderTextArea("message", "Message",'Type your message here' ,null,null,3 )}*/}
                {/*        </div>*/}
                {/*        <div className="submit-buttons row">*/}
                {/*            <div className="col-md-6">*/}
                {/*                <button disabled={false}*/}
                {/*                        onClick={onClickAway}*/}
                {/*                        name="cancel_team"*/}
                {/*                        id="cancel_team"*/}
                {/*                        type="button"*/}
                {/*                        className='btn-transparent-border btn-xs text-bold'>Cancel*/}
                {/*                </button>*/}
                {/*            </div>*/}
                {/*            <div className="col-md-6 text-right save-submit">*/}
                {/*                <button disabled={!this.state.data.message}*/}
                {/*                        name="change_team"*/}
                {/*                        id="submit_contact_support"*/}
                {/*                        type="button"*/}
                {/*                        onClick={this.doSubmit}*/}
                {/*                        className='btn-action btn-lg m-xl-b'>Submit*/}
                {/*                </button>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        )
    }
}

export default ContactSupportModal;